import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { DownloadIcon } from '../../../assets/icons/index';
import Button from '../../../components/button/index';

export type LibraryResourceCardProps = {
  availableIn: string[];
  category: string;
  className?: string;
  coverImage: string;
  description: string;
  onDownload?: () => void;
  title: string;
};

export const LibraryResourceCard: FC<LibraryResourceCardProps> = ({
  availableIn,
  category,
  className,
  coverImage,
  description,
  onDownload,
  title,
}) => {
  return (
    <div
      className={twMerge(
        'flex h-full flex-col overflow-hidden rounded-xl border border-gray-200 bg-white',
        className,
      )}
    >
      <div className="relative h-[245px] w-full shrink-0 overflow-hidden border-b border-gray-200 bg-gray-25">
        <img alt={title} className="h-full w-full object-cover" src={coverImage} />
      </div>
      <div className="flex min-h-0 flex-1 flex-col gap-5 p-4">
        <div className="flex min-h-0 flex-1 flex-col gap-2">
          <span className="text-[10px] font-semibold text-gray-500">{category}</span>
          <span className="text-[27px] font-medium text-black">{title}</span>
          <span className="mt-2 text-sm font-[450] text-gray-600">{description}</span>
        </div>
        <div className="flex shrink-0 flex-row justify-between gap-4">
          <div className="flex flex-col">
            <span className="text-xs text-gray-700">Available in:</span>
            <span className="text-[10px] text-gray-500">{availableIn.join(', ')}</span>
          </div>
          <div className="flex w-fit justify-end">
            <Button
              className="centered size-9 rounded-[4px] border border-gray-100 bg-gray-25"
              onClick={onDownload}
              styleType="NONE"
            >
              <DownloadIcon className="size-4" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
